// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3f8206fc","977":"b242621d"}[chunkId] + ".chunk.js";
};